import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase';
import { 
  collection, 
  query, 
  where, 
  getDocs, 
  doc, 
  setDoc,
  writeBatch, // Add this
  arrayUnion // Add this
} from 'firebase/firestore';

export default function useUrlTracking() {
  const { currentUser } = useAuth();
  const location = useLocation();

  // Update the hook to handle both characters and chapters
useEffect(() => {
  const checkUrlUnlocks = async () => {
    if (!currentUser?.uid) return;

    try {
      // Get both characters and chapters that require this URL
      const [charsSnapshot, chapsSnapshot] = await Promise.all([
        getDocs(query(
          collection(db, 'characters'),
          where('requiredUrl', '==', location.pathname)
        )),
        getDocs(query(
          collection(db, 'chapters'),
          where('requiredUrl', '==', location.pathname)
        ))
      ]);

      const characterIds = charsSnapshot.docs.map(doc => doc.id);
      const chapterIds = chapsSnapshot.docs.map(doc => doc.id);

      if (characterIds.length === 0 && chapterIds.length === 0) return;

      // Update user unlocks
      const userUnlocksRef = doc(db, 'userUnlocks', currentUser.uid);
      const batch = writeBatch(db);
      
      batch.set(userUnlocksRef, {
        unlockedCharacters: arrayUnion(...characterIds),
        unlockedChapters: arrayUnion(...chapterIds)
      }, { merge: true });

      await batch.commit();
      
    } catch (error) {
      console.error('Unlock error:', error);
    }
  };

  checkUrlUnlocks();
}, [location.pathname, currentUser?.uid]);
}